import { EXOTEL_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { IPaymentWalletTypeResponse } from "@/api_framework/api_modals/payment";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string; data?: any };

export const useUserCallDetailsAPI = () => {
  const configuration = useConfiguration();
  const [userCallDetails, setUserCallDetails] = useState<any>(null);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (customerId?: string, phoneNumber?: string, crtid?: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const queryParams = new URLSearchParams();
        if (customerId) {
          queryParams.set("customer_id", customerId);
        }
        if (phoneNumber) {
          queryParams.set("phone", phoneNumber);
        }
        if (crtid) {
          queryParams.set("crt_id", crtid);
        }
        const queryString = queryParams.toString();
        const requestUrl = queryString
          ? `${EXOTEL_APIS?.EXOTEL_CALL_DETAILS?.baseURL}?${queryString}`
          : `${EXOTEL_APIS?.EXOTEL_CALL_DETAILS?.baseURL}`;
        const response: ICartAPIResponse = await axios
          .get(requestUrl, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPaymentWalletTypeResponse>) => {
            if (res.data.status) {
              setUserCallDetails(res.data.data);

              return { status: true, message: "Cart Level Coupons Fetched", data: res.data.data };
            } else {
              setUserCallDetails([]);

              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            setUserCallDetails([]);
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        setUserCallDetails([]);
        captureError(e);
      }
    },
    [dispatch],
  );
  return { userCallDetails, execute };
};
